import { axiosProxy } from '@/plugins/axios'
import { categories } from '../../../config'

export const usePreferenceStore = () => {
  let lifts = (window as any).Taiko ? (window as any).Taiko.lifts : []
  let links = (window as any).Taiko ? (window as any).Taiko.links : []

  const fetchItems = async () => {
    // Check if already available from laravel JavaScript
    if (!lifts || lifts.length === 0) {
      const res = await axiosProxy.get(`preferences?include=lifts,links`)
      lifts = res.data['data'].lifts
      links = res.data['data'].links
    }
    return { lifts, links }
  }

  function findLift (criteria) {
    return lifts.find(lift => {
      return Object.keys(criteria).every(key => {
        return lift[key] === criteria[key]
      })
    })
  }

  function getMap () {
    return lifts.reduce((map, lift) => {
      map[`${lift.component}:${lift.position}`] = lift
      return map
    }, {})
  }

  function getCategories () {
    return categories.map((c: any) => {
      const linkBySlug = links.find((link) => link.key === c.slug)
      if (linkBySlug && linkBySlug.image && linkBySlug.image.url) {
        c.image = linkBySlug.image.url
      }
      c.count = linkBySlug.count || 0
      return {
        ...c,
        image: {
          url: c.image,
        },
      }
    })
  }

  return {
    fetchItems,
    findLift,
    getMap,
    getCategories
  }
}
